module.exports = __webpack_public_path__ + "static/resume-4a0fe2ef3773d4450ce5a2a25b294933.pdf";